// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterNavBlock_title__LnmR0","item":"FooterNavBlock_item__aVGGv","link":"FooterNavBlock_link__xyDZq"};